import { AnimatePresence, motion } from 'framer-motion';
import { FC, ForwardedRef, ReactNode, forwardRef } from 'react';
import { useAccordianContext } from '../context/accordian-context';
import { accordianAnimation } from '../helpers/accordian.animations';

interface AccordianCollapseProps {
    children: ReactNode;
    ref?: ForwardedRef<HTMLDivElement>;
}

const AccordianCollapse = forwardRef((props: AccordianCollapseProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { children } = props;

    const { isExpanded } = useAccordianContext();

    return (
        <AnimatePresence initial={false} mode="wait">
            {isExpanded && (
                <motion.div {...accordianAnimation} ref={ref} className="overflow-hidden">
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
});

export default AccordianCollapse;
